'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Dashboard$Tips$() {
}
export { $c_Lpresto_Dashboard$Tips$ as $c_Lpresto_Dashboard$Tips$ };
$p = $c_Lpresto_Dashboard$Tips$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Dashboard$Tips$;
/** @constructor */
function $h_Lpresto_Dashboard$Tips$() {
}
export { $h_Lpresto_Dashboard$Tips$ as $h_Lpresto_Dashboard$Tips$ };
$h_Lpresto_Dashboard$Tips$.prototype = $p;
$p.cCc = (function(all) {
  return (("Credenciais do tipo Certificado e PIN e A3 F\u00edsico usadas em ao menos um login neste m\u00eas" + (all ? ", de todas as contas" : "")) + ", mesmo que tenham sido exclu\u00eddas depois. A cobran\u00e7a \u00e9 feita sobre as utilizadas; as cadastradas no cofre aparecem s\u00f3 como refer\u00eancia.");
});
$p.cQm = (function(all) {
  return (("Usu\u00e1rios com ao menos um login pelo Presto neste m\u00eas" + (all ? ", de todas as contas" : "")) + ". \u00c9 a contagem usada na cobran\u00e7a e n\u00e3o muda com o filtro de per\u00edodo.");
});
var $d_Lpresto_Dashboard$Tips$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Dashboard$Tips$, "presto.Dashboard$Tips$", ({
  H6: 1
}));
export { $d_Lpresto_Dashboard$Tips$ as $d_Lpresto_Dashboard$Tips$ };
var $n_Lpresto_Dashboard$Tips$;
function $m_Lpresto_Dashboard$Tips$() {
  if ((!$n_Lpresto_Dashboard$Tips$)) {
    $n_Lpresto_Dashboard$Tips$ = new $c_Lpresto_Dashboard$Tips$();
  }
  return $n_Lpresto_Dashboard$Tips$;
}
export { $m_Lpresto_Dashboard$Tips$ as $m_Lpresto_Dashboard$Tips$ };
//# sourceMappingURL=presto.-Dashboard$-Tips$.js.map
